<script setup lang="ts">
  import { computed, inject, unref, type ComputedRef, type Ref } from 'vue'
  import AiChatMessageInputAssistant from './AiChatMessageInputAssistant.vue'
  import AiChatMessageInputLegacy from './AiChatMessageInputLegacy.vue'

  const isAiAssistantAppRoute = inject<Ref<boolean> | ComputedRef<boolean>>(
    'isAiAssistantAppRoute',
    computed(() => false)
  )
</script>

<template>
  <AiChatMessageInputAssistant v-if="unref(isAiAssistantAppRoute)" />
  <AiChatMessageInputLegacy v-else />
</template>
